import Historic from "./Historic";

export default Historic;
